import './Home.scss';
import { useMemo, useState } from 'react';
import cn from 'classnames';
import Page from "@containers/Page/Page";
import PageContent from "@containers/PageContent/PageContent";
import { CustomBaseScrollbars } from "@components/CustomScrollbarsVirtualList/CustomScrollbarsVirtualList";
import HomeFoods from "@pages/Home/sections/HomeFoods/HomeFoods";
import HomeTrending from "@pages/Home/sections/HomeTrending/HomeTrending";
import HomePlaces from "@pages/Home/sections/HomePlaces/HomePlaces";
import HomeRecentSearches from '@pages/Home/sections/HomeRecentSearches/HomeRecentSearches';
import TabList from '@components/new/TabList/TabList';
import { getSectionId } from '@helpers';
import HomeSection from "@pages/Home/components/HomeSection";
import { cssX, usePlatformContext, usePlatformFeatureFlag, SearchOnKeyDownInit } from "@datassential/platform-ui-lib";
import HomeReportsAndNews from "@pages/Home/sections/HomeReportsAndNews/HomeReportsAndNews";


export const HOME_PAGE_SCROLLBAR_ID = 'HomePageScrollbar';
const HOME_NAVIGATION_OFFSET = 32;

const Home = () => {

    const [isScrolled, setIsScrolled] = useState(false);
    const { isUserInfoLoaded } = usePlatformContext();
    const isNewsEnabled = usePlatformFeatureFlag('SNAP home news');

    const homeSections = useMemo(
        () => [
            {
                id: 'news-reports',
                title: isNewsEnabled ? 'News & Reports' : 'Reports',
                testId: 'blockHomeReports',
                Component: HomeReportsAndNews
            },
            { id: 'trendingNow', title: "Trending Now", testId: 'blockHomeTrendingNow', Component: HomeTrending },
            { id: 'foods', title: 'Foods', testId: 'blockHomeFoods', Component: HomeFoods },
            { id: 'places', title: 'Places', testId: 'blockHomePlaces', Component: HomePlaces },
            { id: 'recentSearches', title: 'Recent Searches', testId: 'blockHomeRecentSearches', Component: HomeRecentSearches },
        ],
        [isNewsEnabled]
    );


    const isLastSection = (index: number) => index === homeSections.length - 1;

    if (!isUserInfoLoaded) {
        return <div className="Home"/>;
    }

    return (
        // @ts-ignore
        <Page>
            <PageContent>
                <SearchOnKeyDownInit/>
                <CustomBaseScrollbars
                    id={HOME_PAGE_SCROLLBAR_ID}
                    onScroll={(event: any) => {
                        setIsScrolled(event?.target?.scrollTop > 0);
                    }}
                >
                    <div className="Home">
                        <TabList
                            className={cn(
                                "Home__navigation",
                                cssX('-use-rem'),
                                isScrolled && "Home__navigation--scrolled",
                            )}
                            data={homeSections}
                            containerId={HOME_PAGE_SCROLLBAR_ID}
                            offset={HOME_NAVIGATION_OFFSET}
                        />
                        {homeSections.map(({ id, testId, Component }, index) => (
                            <HomeSection
                                key={id}
                                id={getSectionId(id)}
                                className={cn({ 'HomeSection--last': isLastSection(index) })}
                                testId={testId}
                            >
                                <Component />
                            </HomeSection>
                        ))}
                    </div>
                </CustomBaseScrollbars>
            </PageContent>
        </Page>
    );
}

export default Home;